<template>
  <div id="newGift-view">
    <div id="">
      <p>&nbsp;{{ newCardAmount }}</p>
      <ul>
        <li v-for="(item, $index) in list" v-bind:key="$index">
          <p><span>{{ item.nominalValue }}</span>元</p>
          <p>新人返现券</p>
          <p>出借满{{ item.quttMinInvest }}元</p>
          <p>项目期限{{ item.quttProjectDeadline }}天起可用</p>
        </li>
      </ul>
      <router-link tag="div" :to="{path: isLogin ? '/accountTotal/cardVoucher' : '/register'}" class="toRegister">{{ isLogin ? '立即查看' : '立即领取' }}</router-link>
      <router-link tag="div" to="/index/help.html" class="toNoviceGuidance"></router-link>
    </div>
  </div>
</template>

<script>
export default{
  data () {
    return {
      isLogin: false
    }
  },
  computed: {
    list () {
      return this.$store.state.appStore.newCardAmountList
    }
  },
  mounted () {
    this.verifyLogin().then((res) => {}).catch(() => {})
  }
}
</script>

<style lang="less">
#newGift-view{
  background: url(../../assets/images/newGift-bg.png) no-repeat 50% 0;
  background-color: #d53f3f;
  >div{
    width: 1200px;
    min-height: 1240px;
    margin: 0 auto;
    padding-top: 200px;
    >p {
      text-align: center;
      font-family: 'DINBold';
      color: rgb( 213, 63, 63 );
      font-size: 74px;
      text-align: center;
      line-height: 74px;
    }
    ul{
      display: flex;
      margin: 0 auto;
      justify-content: center;
      margin-top: 215px;
      text-align: center;
      color: #bb7b41;
      font-size: 14px;
      li{
        width: 204px;
        height: 150px;
        background: url(../../assets/images/newFift-voucherBg.png) no-repeat;
        p:first-child, p:nth-child(2){
          font-size: 16px;
          &:first-child{
            color: #d53f3f;
            padding-top: 18px;
            height: 28px;
            span{
              font-size: 36px;
              line-height: 28px;
              height: 28px;
              display: inline-block;
              font-family: 'DINBold';
            }
          }
        }
        p:nth-child(2){
          line-height: 16px;
          height: 16px;
          margin-top: 10px;
          margin-bottom: 22px;
        }
        p:nth-child(3), p:nth-child(4){
          height: 14px;
          line-height: 14px;
          margin-bottom: 5px;
        }
      }
    }
    .toRegister, .toNoviceGuidance{
      width: 400px;
      height: 72px;
      line-height: 72px;
      text-align: center;
      font-size: 24px;
      color: #904504;
      border-radius: 36px;
      margin: 0 auto;
      cursor: pointer;
      &.toRegister{
        background-image: linear-gradient( 90deg, rgb(255,196,142) 0%, rgb(255,185,122) 100%);
        margin-top: 36px;
      }
      &.toNoviceGuidance{
        margin-top: 280px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/information/newGift.vue